import {ReactSVG} from "react-svg";

export const TextFriLightIcon = () => {
    return (
        <ReactSVG src={"/fri-media/login-icon-left.svg"}></ReactSVG>
    );
};